module.exports = __webpack_public_path__ + "img/bmw_sw.e7c470cf.png";